import { render, staticRenderFns } from "./SessionScore.vue?vue&type=template&id=935751b4&scoped=true&"
import script from "./SessionScore.vue?vue&type=script&lang=js&"
export * from "./SessionScore.vue?vue&type=script&lang=js&"
import style0 from "./SessionScore.vue?vue&type=style&index=0&id=935751b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935751b4",
  null
  
)

export default component.exports